import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export interface TableEmptyProps {
  children?: ReactNode;
  className?: string;
}

/** Rendered in place of the rows when there are none and the table is not loading. */
export const TableEmpty = ({ children, className }: TableEmptyProps) => (
  <div
    data-slot="table-empty"
    className={cn("flex flex-1 items-center justify-center p-6 text-sm text-muted-foreground", className)}
  >
    {children}
  </div>
);
